import sanitizedData from "@/core/helpers/sanitizedData";

type Props = {
  text: string | null | undefined;
  children: React.ReactNode;
};

export default function NotificationsOfferBody({ text, children }: Props) {
  return (
    <div className="w-[16.875rem] p-[0.125rem] bg-gradient-to-r from-dark-900/60 to-dark-900/80 rounded-xl pointer-events-auto">
      <div className="relative size-full px-3 pt-3 pb-4 bg-gradient-to-t from-white/6 to-transparent rounded-lg overflow-hidden">
        <p
          className="mb-[0.625rem] font-medium text-14"
          dangerouslySetInnerHTML={sanitizedData(text)}
        />
        <div className="flex gap-[0.625rem]">{children}</div>
      </div>
    </div>
  );
}
